import { render, staticRenderFns } from "./NotificationMain.vue?vue&type=template&id=5ea6bb86&"
import script from "./NotificationMain.vue?vue&type=script&lang=ts&"
export * from "./NotificationMain.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports